import type { FC } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible, AiOutlineUser } from "react-icons/ai";
import { MdOutlineNumbers } from "react-icons/md";
import { TbLock } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { MoonLoader } from "react-spinners";
import fondoImagen from "../../images/fondo.png";
import logoImagen from "../../images/logo.png";
import { useRegisterPage } from "./registerPageHooks";
import type { RegisterPageProps } from "./types";

export const RegisterPage: FC<RegisterPageProps> = () => {
  const navigate = useNavigate();
  const {
    isSubmiting,
    isButtonPassword,
    rutas,
    canSubmit,
    changeTypeText,
    handleUsuarioChange,
    handleNombreChange,
    handleRutasChange,
    handleContrasenaChange,
    handleContrasenaVerifyChange,
    handleSubmit,
  } = useRegisterPage({
    navigate,
  });

  return (
    <div className="w-full overflow-hidden box-border relative h-screen flex justify-center flex-col gap-4 items-center">
      <img
        src={fondoImagen}
        alt="fondo"
        className="w-full h-full object-cover z-[-10] absolute left-0 top-0 opacity-70 blur"
      />

      <div className="login-container bg-gray-100 flex flex-col gap-4 justify-center items-center border shadow-[2px_2px_6px_rgb(0,0,0,0.5)] rounded-md px-3 py-4 w-[90%] md:w-[350px]">
        <div className="flex justify-center flex-col items-center">
          <img src={logoImagen} alt="logo" className="w-[160px] h-[160px]" />
          <h3 className="font-bold text-base uppercase text-[#8131bd] mt-[-10px]">
            Facilidad y Eficiencia
          </h3>
        </div>

        <h2 className="text-2xl mb-4">Registro de Administradores</h2>

        <form className="w-full" onSubmit={handleSubmit}>
          <div className="w-full flex flex-col gap-2 items-center">
            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[40px] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                <AiOutlineUser size={24} />
              </div>
              <input
                type="text"
                className="flex-1 rounded-md w-full px-2 focus:border-transparent focus:outline-none"
                placeholder="Usuario"
                onChange={handleUsuarioChange}
                required
              />
            </div>

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[40px] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                <AiOutlineUser size={24} />
              </div>
              <input
                type="text"
                className="flex-1 rounded-md w-full px-2 focus:border-transparent focus:outline-none"
                placeholder="Nombre"
                onChange={handleNombreChange}
                required
              />
            </div>

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[40px] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                <MdOutlineNumbers size={24} />
              </div>
              <input
                type="number"
                className="flex-1 rounded-md w-full px-2 focus:border-transparent focus:outline-none"
                placeholder="Numero de Rutas"
                value={rutas}
                onChange={handleRutasChange}
              />
            </div>

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[40px] bg-gray-200 flex items-center justify-center border-gray-400 rounded-l-md border-r">
                <TbLock size={24} />
              </div>
              <input
                type={isButtonPassword ? "password" : "text"}
                className="flex-1 rounded-md w-full px-2 focus:border-transparent focus:outline-none"
                placeholder="Contrasena"
                onChange={handleContrasenaChange}
                required
              />
              <div className="h-full w-[40px] bg-white rounded-md flex items-center justify-center ">
                {isButtonPassword ? (
                  <AiOutlineEye onClick={changeTypeText} className="text-gray-500" size={24} />
                ) : (
                  <AiOutlineEyeInvisible
                    onClick={changeTypeText}
                    className="text-gray-500"
                    size={24}
                  />
                )}
              </div>
            </div>
            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[40px] bg-gray-200 flex items-center justify-center border-gray-400 rounded-l-md border-r">
                <TbLock size={24} />
              </div>
              <input
                type={isButtonPassword ? "password" : "text"}
                className="flex-1 rounded-md w-full px-2 focus:border-transparent focus:outline-none"
                placeholder="Verificar Contrasena"
                onChange={handleContrasenaVerifyChange}
                required
              />
              <div className="h-full w-[40px] bg-white rounded-md flex items-center justify-center ">
                {isButtonPassword ? (
                  <AiOutlineEye onClick={changeTypeText} className="text-gray-500" size={24} />
                ) : (
                  <AiOutlineEyeInvisible
                    onClick={changeTypeText}
                    className="text-gray-500"
                    size={24}
                  />
                )}
              </div>
            </div>
            <button
              type="submit"
              className="bg-[#8131bd] w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
              disabled={!canSubmit}
            >
              {isSubmiting ? <MoonLoader size={20} color="#ffffff" /> : "Registrar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
